import * as z from 'zod/v4';

import { isActiveWalletChainKey, type ChainKey } from './chains';

/**
 * Zod schema for a chain key that must be active and support wallets.
 * Shared across all v2 contracts that take chain identifiers as input.
 *
 * Output type is narrowed to `ChainKey` via a `.transform` cast (Zod v4's
 * `.refine` with a type predicate does NOT narrow `z.infer` output — it
 * still resolves to the input type).
 */
export const chainKeySchema = z
  .string()
  .refine((chain): chain is ChainKey => {
    return isActiveWalletChainKey(chain as ChainKey);
  }, 'Invalid chain key — chain must be active and support wallets')
  .transform((chain) => chain as ChainKey);
